@import "config";

@keyframes pulse {
	0%,
	100% {
		transform: scale(0.4);
	}
	50% {
		transform: scale(1);
	}
}

.pulsingDot {
	width: 10px;
	height: 10px;
	border-radius: $border-radius-pill;
	position: relative;
	@include flex(row, center, center);
}

.pulsingDot::after {
	content: "";
	width: 10px;
	height: 10px;
	border-radius: $border-radius-pill;
	background-color: $color-success-medium;
	opacity: 0.5;
}

.pulsingDot::before {
	content: "";
	width: 10px;
	height: 10px;
	border-radius: $border-radius-pill;
	animation: pulse 2s infinite ease-in-out;
	background-color: $color-success-medium;
	position: absolute;
}

.runningEvents {
	@include flex(row, unset, center);
	gap: $spacing-inline-quarck;
	background-color: $color-light-l5;
	padding: $spacing-inline-quarck;
	border-radius: calc($border-radius-md / 2);
	flex-shrink: 0;

	&.onlyPulsingDot {
		border-radius: $border-radius-md;
	}

	small {
		color: $color-success-dark;
		font-weight: $font-weight-bold;
		font-size: 10px;
		line-height: $font-line-heights-compact;
		text-transform: uppercase;
	}
}
